import { renderPage } from "renderPage"
import { UserSecurityForgottenPage } from "./Page"

renderPage({ component: UserSecurityForgottenPage })
